import { h, Component } from 'preact'
import ReactTooltip from 'react-tooltip'
import {
  supportColors,
  colors,
  transition,
  administrationDisclaimer,
} from '../../constants'
import { Block } from '../layout'
import { Link } from '../visual'
import hoverable from '../hoverable'

import panacekRest from '../../assets/panacek-rest.png'
import panacekRestNoSupport from '../../assets/panacek-rest-no-support.png'

const toLowerIfString = s => (typeof s === 'string' ? s.toLowerCase() : s)

const PoliticianImage = hoverable(
  class PoliticianImageImpl extends Component {
    render() {
      const { data, hover, party } = this.props
      return (
        <div
          style={{ position: 'relative', background: '#000' }}
          onMouseEnter={this.props.onMouseEnter}
          onMouseLeave={this.props.onMouseLeave}
        >
          <Link href={data.person.url}>
            <img
              alt=""
              style={{
                width: '100%',
                height: 138,
                backgroundImage: `url(https://rekonstrukcestatu.cz${data.person
                  .img})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                WebkitFilter: 'grayscale(100%)',
                Filter: 'grayscale(100%)',
                transition,
                opacity: hover ? 0.5 : 1,
              }}
            />
            <span
              style={{
                position: 'absolute',
                left: 0,
                top: 0,
                width: '100%',
                transition,
                height: hover ? 30 : 5,
                background: (() => {
                  if (party.stripeColor) return party.stripeColor
                  if (party.stripeURL)
                    return `url(https://rekonstrukcestatu.cz${party.stripeURL}) 0 0 repeat-y`
                  return 'transparent'
                })(),
              }}
            />
            <span
              style={{
                color: '#fff',
                position: 'absolute',
                left: 0,
                bottom: 60,
                width: '100%',
                display: hover ? 'block' : 'none',
              }}
            >
              {data.person.party}
            </span>
          </Link>
        </div>
      )
    }
  },
)

class Politician extends Component {
  render() {
    const { data, party, hidden } = this.props
    const fullf = toLowerIfString(data.pledge.fullfillment[0])
    return (
      <div
        style={{
          letterSpacing: 0,
          width: 120,
          paddingLeft: 5,
          margin: '0 0 0 0',
          textAlign: 'center',
          display: hidden ? 'none' : 'inline-block',
          verticalAlign: 'middle',
        }}
      >
        <div
          style={{
            margin: 0,
            height: 55,
            position: 'relative',
          }}
        >
          <h3
            style={{
              fontSize: 16,
              lineHeight: '22px',
              margin: '0 0 5px 0',
              width: '100%',
              position: 'absolute',
              top: '50%',
              transform: 'translateY(-50%)',
            }}
          >
            <Link href={data.person.url}>
              {data.person.name.firstname} {data.person.name.surname}
            </Link>
          </h3>
        </div>
        <PoliticianImage data={data} party={party} />
        <div
          style={{
            backgroundColor: data.person.administration
              ? colors.darkGrey
              : supportColors[data.all.category],
            fontSize: 15,
            fontFamily: 'bariol,arial',
            fontWeight: 'bold',
            padding: 10,
            borderRadius: '0 0 0 5px',
            lineHeight: '18px',
            height: 54,
            verticalAlign: 'middle',
            display: 'table-cell',
            width: 120,
            color: '#fff',
            textAlign: 'center',
          }}
          data-tip={data.person.administration ? administrationDisclaimer : ''}
        >
          {data.person.administration ? 'člen vlády' : data.all.category}
        </div>
        <div
          style={{
            color: '#6a6a6a',
            fontFamily: 'bariol,arial',
            height: 45,
            lineHeight: '1.2em',
          }}
        >
          <span
            style={{
              backgroundColor: 'transparent',
              // backgroundImage: "url('/static/img/panacek_rest_no_support.png')",
              backgroundImage: (() => {
                if (fullf === 'plní slib') return `url(${panacekRest})`
                if (fullf === 0) return undefined
                return `url(${panacekRestNoSupport})`
              })(),
              backgroundPosition: 'right',
              backgroundRepeat: 'no-repeat',
              backgroundPositionY: 0,
              backgroundSize: 'contain',
              paddingRight: fullf === 0 ? 0 : 20,
              fontSize: '15px',
              // backgroundSize: 'contain',
            }}
          >
            {(data.pledge.fullfillment[0] ||
              (data.person.gender === 'M' ? 'Nezavázal se' : 'Nezavázala se')
            ).replace(
              'porušil',
              data.person.gender === 'M' ? 'porušil' : 'porušila',
            )}
          </span>{' '}
        </div>
      </div>
    )
  }
}

export default ({ list, parties }) => (
  <Block>
    <div style={{ minHeight: 311, textAlign: 'center' }}>
      {list.length > 0 ? (
        list.map(p => (
          <Politician
            party={parties[p.person.party] || {}}
            data={p}
            key={`${p.person.name.firstname} ${p.person.name.surname}`}
            hidden={p.hidden}
          />
        ))
      ) : (
        <div
          style={{
            letterSpacing: 0,
            textAlign: 'center',
            width: '100%',
          }}
        >
          Tomuto výběru neodpovídá žádný politik
        </div>
      )}
    </div>
    <ReactTooltip multiline effect="solid" class="tooltip" />
  </Block>
)



// WEBPACK FOOTER //
// ./components/PoliticianList/PoliticianList.js